import request from '@/utils/request'
// 登录
export function login(data) {
  return request({
    url:'/filmaccount/v100/pcLogin',
    method:'post',
    data:data
  })
}
// 判断是否登录
export function isLogin(data) {
  return request({
    url: '/filmaccount/v100/isLogin',
    method: 'post',
    data: data
  })
}
// 获取个人中心
export function getSurplusMoneyUrl(data) {
  return request({
    url: '/filmaccount/mine/surplusMoney',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js